import { useState } from 'react';
import { useGameContext } from '@/state/GameContext';
import { ItemBrowser } from '@/components/ItemBrowser';
import { CraftingStation } from '@/components/CraftingStation';
import { RecipeBook } from '@/components/RecipeBook';
import { DiscoveryGraph } from '@/components/DiscoveryGraph';
import { InventoryPanel } from '@/components/InventoryPanel';
import { HistoryPanel } from '@/components/HistoryPanel';
import { SettingsPanel } from '@/components/SettingsPanel';
import { DevPanel } from '@/components/DevPanel';
import { MINECRAFT_VERSION } from '@/data/vanillaRecipes';

type Tab = 'book' | 'graph' | 'inventory' | 'history';

export function App() {
  const game = useGameContext();
  const [tab, setTab] = useState<Tab>('book');
  const [showSettings, setShowSettings] = useState(false);

  if (!game.ready) {
    return (
      <div className="app">
        <div className="spinner-overlay">Loading Infinite Crafting Table...</div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="header">
        <span className="title">
          <img src={`${import.meta.env.BASE_URL}textures/block/crafting_table_front.png`} alt="" style={{ width: 22, height: 22, imageRendering: 'pixelated' }} />
          Infinite Crafting Table
        </span>
        <span className="stat">Discovered <b>{game.discoveryCount}</b></span>
        <span className="stat">Collected <b>{Object.values(game.inventory).reduce((a, b) => a + b, 0)}</b></span>
        <span className="stat" title={MINECRAFT_VERSION}>{MINECRAFT_VERSION.split(' ')[0]} {MINECRAFT_VERSION.split(' ')[1]}</span>
        <span className="spacer" />
        <button className="btn ghost" onClick={() => game.updateSettings({ sound: !game.settings.sound })} title="Toggle sound">
          {game.settings.sound ? '\u266B' : '\u266B\u0338'}
        </button>
        {game.settings.devMode ? (
          <button className="btn ghost" onClick={() => game.updateSettings({ devMode: false })}>Hide dev</button>
        ) : (
          <button className="btn ghost" onClick={() => game.updateSettings({ devMode: true })} title="Enable developer panel">Dev</button>
        )}
        <button className="btn" onClick={() => setShowSettings(true)}>Settings</button>
      </header>

      <main className="main">
        <ItemBrowser />
        <CraftingStation />
        <div className="panel">
          <div className="tabs">
            {(['book', 'graph', 'inventory', 'history'] as Tab[]).map((t) => (
              <button key={t} className={`tab${tab === t ? ' active' : ''}`} onClick={() => setTab(t)}>
                {t === 'book' ? 'Recipe Book' : t === 'graph' ? 'Graph' : t === 'inventory' ? 'Inventory' : 'History'}
              </button>
            ))}
          </div>
          {tab === 'book' ? <RecipeBook /> : null}
          {tab === 'graph' ? <DiscoveryGraph /> : null}
          {tab === 'inventory' ? <InventoryPanel /> : null}
          {tab === 'history' ? <HistoryPanel /> : null}
        </div>
      </main>

      {game.settings.devMode ? <DevPanel /> : null}
      {showSettings ? <SettingsPanel onClose={() => setShowSettings(false)} /> : null}
    </div>
  );
}
